import { render } from "./PedidosLista.vue?vue&type=template&id=7ffd134b"
import script from "./PedidosLista.vue?vue&type=script&lang=js"
export * from "./PedidosLista.vue?vue&type=script&lang=js"

import "./PedidosLista.vue?vue&type=style&index=0&id=7ffd134b&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__